import React from 'react'
import styles from './HtmlContent.module.css'

export default function HtmlContent(props) {
  const { content, className, ...rest } = props

  return (
    <div
      {...rest}
      className={[className, styles.container]}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
